import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { stateOptions } from '@/config';

dayjs.extend(customParseFormat);

export default function (programName: string) {
  let doseageLabel = 'Dosage';
  if (['octagam', 'panzyga', 'cutaquig'].includes(programName)) {
    doseageLabel = 'Number of gms for this Fill';
  } else if (['nuwiq', 'wilate'].includes(programName)) {
    doseageLabel = 'Number of units for this Fill';
  } else if (['Fibryga'].includes(programName)) {
    doseageLabel = 'Number of mgs for this Fill';
  }

  return {
    prescriberFields: [
      {
        name: 'prescriber_first_name',
        type: 'input',
        label: 'Legal First Name',
        required: true,
        span: 12,
      },
      {
        name: 'prescriber_last_name',
        type: 'input',
        label: 'Legal Last Name',
        required: true,
        span: 12,
      },
      {
        name: 'prescriber_facility_name',
        type: 'input',
        label: 'Facility Name',
        span: 12,
      },
      {
        name: 'prescriber_specialty',
        type: 'input',
        required: true,
        label: 'Specialty',
        span: 12,
      },
      {
        label: 'Prescriber NPI',
        name: 'prescriber_npi',
        type: 'otp',
        length: 10,
        span: 12,
        required: true,
      },
      {
        label: 'Professional Designation',
        name: 'prescriber_professional_designation',
        type: 'input',
        span: 12,
        required: true,
      },
      {
        label: 'State License Number',
        name: 'prescriber_state_license_number',
        type: 'input',
        span: 12,
        required: true,
      },
      {
        label: 'Prescriber address',
        name: 'prescriber_address_line1',
        type: 'text',
        span: 12,
        required: true,
        placeholder: 'Please enter the address',
      },
      {
        label: 'Prescriber address line 2',
        name: 'prescriber_address_line2',
        type: 'text',
        span: 12,
        placeholder: 'Please enter the address line 2',
      },
      {
        label: 'Prescriber city',
        name: 'prescriber_city',
        type: 'text',
        span: 12,
        required: true,
        placeholder: 'Please enter the city',
      },
      {
        label: 'Prescriber state',
        name: 'prescriber_state',
        type: 'select',
        span: 12,
        required: true,
        options: stateOptions,
        placeholder: 'Please select the state',
      },
      {
        label: 'Prescriber zip code',
        name: 'prescriber_zip_code',
        type: 'otp',
        length: 5,
        span: 12,
        required: true,
      },
      {
        label: 'Phone Number',
        name: 'prescriber_phone_number',
        type: 'otp',
        length: 10,
        span: 12,
        required: true,
      },
    ],
    prescriptionFields: [
      programName === 'octagam'
        ? {
            label: 'Strength',
            name: 'prescription_strength',
            required: true,
            type: 'select',
            span: 12,
            options: [
              { value: '5%', label: '5%' },
              { value: '10%', label: '10%' },
            ],
          }
        : {
            label: 'Strength',
            name: 'prescription_strength',
            required: true,
            type: 'input',
            span: 12,
          },
      {
        label: doseageLabel,
        name: 'prescription_dosage',
        required: true,
        type: 'input',
        span: 12,
      },
      {
        label: 'Product used in the past',
        name: 'prescription_is_used',
        type: 'select',
        span: 12,
        options: [
          { value: true, label: 'Yes' },
          { value: false, label: 'No' },
        ],
      },
      {
        label: 'Provider Name',
        name: 'prescription_specialty_pharmacy_name',
        type: 'input',
        span: 12,
      },
      {
        label: 'Additional Prescriber Instructions',
        name: 'prescription_additional_prescriber_instructions',
        span: 12,
        type: 'textarea',
      },
    ],
    signatureFields: [
      {
        label: "Patient or Legal Guardian's Signature",
        name: 'patient_e_signature',
        type: 'input',
        required: true,
        span: 12,
      },
      {
        label: 'Date',
        name: 'patient_signature_date',
        type: 'datePicker',
        span: 12,
        disabled: true,
        style: { width: '100%' },
      },
    ],
    licenseFields: [
      {
        label: "Licensed Practitioner's Signature",
        name: 'licensed_prescriber_signature',
        type: 'input',
        required: true,
        span: 12,
      },
      {
        label: 'Date',
        name: 'licensed_prescriber_signature_date',
        type: 'datePicker',
        defaultValue: dayjs(),
        span: 12,
        disabled: true,
        style: { width: '100%' },
      },
    ],
  };
}
